export default __webpack_public_path__ + "static/nyt-e1fc06c8939a4afa9d638640454ec22d.svg";